import { call, put, takeLatest } from "redux-saga/effects";
import request from "@util/net/request";
import { AxiosResponse } from "axios";
import qs from "qs";
import {
  GET_RELATED_STYLING_STYLEHINT,
  GET_STYLEHINT_CAROUSEL_LIST,
  RelatedStylingStylehintActions
} from "@redux/reducer";
import {
  RelatedStylingStylehintPayload,
  StylehintListPayload,
  StylehintListUgcPayload,
  StylehintListUgcResponse
} from "@type/index";
import {
  ContentSearchMapper,
  StylehintNormalQuery,
  StylehintRelatedMapper,
  StylehintRelatedQuery
} from "@util/net/queryParameters";

export function* getRelatedStylingStylehintSaga(action: {
  payload: RelatedStylingStylehintPayload;
}) {
  try {
    const payload: RelatedStylingStylehintPayload = action.payload;
    const _payload: StylehintListUgcPayload = StylehintRelatedQuery(payload);
    yield put(
      RelatedStylingStylehintActions.getRelatedStylingStylehintLoading(true)
    );
    const res: AxiosResponse<StylehintListUgcResponse> = yield call(
      request.get,
      "/contents/search",
      {
        params: { ..._payload },
        paramsSerializer: function (params: StylehintListUgcPayload) {
          return qs.stringify(params, { arrayFormat: "indices" });
        }
      }
    );
    yield put(
      RelatedStylingStylehintActions.getRelatedStylingStylehintSuccess(
        StylehintRelatedMapper(res.data.content_list || [])
      )
    );
  } catch (error) {
    yield put(
      RelatedStylingStylehintActions.getRelatedStylingStylehintLoading(false)
    );
  }
}

export function* getStylehintCarouselListSaga(action: {
  payload: StylehintListPayload;
}) {
  try {
    const payload: StylehintListPayload = action.payload;
    const _payload: StylehintListUgcPayload = StylehintNormalQuery(payload);
    yield put(
      RelatedStylingStylehintActions.getStylehintCarouselListLoading(true)
    );
    const res: AxiosResponse<StylehintListUgcResponse> = yield call(
      request.get,
      "/contents/search",
      {
        params: { ..._payload },
        paramsSerializer: function (params: StylehintListUgcPayload) {
          return qs.stringify(params, { arrayFormat: "indices" });
        }
      }
    );
    yield put(
      RelatedStylingStylehintActions.getStylehintCarouselListSuccess(
        ContentSearchMapper(res.data.content_list || [])
      )
    );
  } catch (error) {
    yield put(
      RelatedStylingStylehintActions.getStylehintCarouselListLoading(false)
    );
  }
}

export function* watchLoadRelatedStylingStylehintSaga() {
  yield takeLatest<any>(
    GET_RELATED_STYLING_STYLEHINT,
    getRelatedStylingStylehintSaga
  );
  yield takeLatest<any>(
    GET_STYLEHINT_CAROUSEL_LIST,
    getStylehintCarouselListSaga
  );
}
